import { render, staticRenderFns } from "./Modelclothes.vue?vue&type=template&id=248e9a52&scoped=true"
import script from "./Modelclothes.vue?vue&type=script&lang=js"
export * from "./Modelclothes.vue?vue&type=script&lang=js"
import style0 from "./Modelclothes.vue?vue&type=style&index=0&id=248e9a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e9a52",
  null
  
)

export default component.exports